
import Vue from 'vue'
import CustomDropdown from '~/components/_general/CustomDropdown.vue'
import SiteSermonsGlobalSelectorDropdown from '~/components/site/sermons/global/SelectorDropdown.vue'

export default Vue.extend({
  name: 'SiteSermonsGlobalLanguageSelector',
  components: { SiteSermonsGlobalSelectorDropdown, CustomDropdown },
  props: {
    sermonId: {
      type: String,
      default: '',
    },
    currentLanguage: {
      type: String,
      default: '',
    },
    targetClasses: {
      type: String,
      default: '',
    },
  },
})
